import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  loading: false,
  deleteCustomerData: {},
  error: "",
  success: false,
  status: "",
};

const deleteCustomerCall = createAsyncThunk(
  "customer/deleteCustomer",
  async () => {
    try {
      const mobile = localStorage.getItem("mobile");
      const result = await axios.post(
        `https://apac.api.capillarytech.com/b2c/x/neo/v1/customers/statuschange?source=INSTORE&identifierName=mobile&identifierValue=${mobile}`,
        {
          reason: "Status changed via Neo",
          label: "Suspended",
        },
        {
          headers: {
            "x-cap-neo-dag-scope": "org",
          },
        }
      );

      return result?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);

const deleteCustomerSlice = createSlice({
  name: "delete-customer",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(deleteCustomerCall.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteCustomerCall.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteCustomerData = action.payload;
      state.success = Boolean(action.payload?.createdId);
      state.error = "";
    });
    builder.addCase(deleteCustomerCall.rejected, (state, action) => {
      state.loading = false;
      state.deleteCustomerData = {};
      state.error = action.error.message;
      state.success = false;
    });
  },
});

export default deleteCustomerSlice.reducer;
export const { reset } = deleteCustomerSlice.actions;
export { deleteCustomerCall };
